module.exports = __webpack_public_path__ + "img/version.a5ebce11.svg";